import { useQuery } from "@tanstack/react-query"

import { PsyAccountSettings, PsychologistDetailed } from "utils/interfaces"
import { ICalendar } from "modules/PsychologistAccount/interfaces"
import { httpClient } from "utils/infrastructure/httpClient"

export const PSY_CALENDAR_LIST_KEY = "psy_calendar_list"
export const PSY_ACCOUNT_DETAILS_KEY = "psy_account_details_key"
export const PSY_ACCOUNT_CLIENTS_LIST_KEY = "psy-client-list"

export interface PsyAccountDetails {
    payment_tools?: PaymentTool
    settings: PsyAccountSettings
    profile: PsychologistDetailed
    has_priority: boolean
}

export interface PaymentTool {
    YooKassaSafe: {
        description: string
        bound: boolean
    }
}

export interface ResponseError {
    message: string
    name: string
}

export interface CalendarResponse {
    result: ICalendar[]
}

export function useAccountDetailsQuery() {
    return useQuery<PsyAccountDetails, ResponseError>([PSY_ACCOUNT_DETAILS_KEY], () =>
        httpClient.get<PsyAccountDetails>("psy-account-details")
    )
}

export function useCalendarsQuery(enabled: boolean, refetchOnWindowFocus = true) {
    return useQuery<ICalendar[], ResponseError>(
        [PSY_CALENDAR_LIST_KEY],
        async () => {
            const data = await httpClient.get<CalendarResponse>("psy-calendar-list")
            return data.result
        },
        { enabled, refetchOnWindowFocus }
    )
}

export function useGetCurrentCalendar() {
    const { data: accountDetails, isLoading } = useAccountDetailsQuery()
    const { data: calendars, isLoading: isCalendarsLoading } = useCalendarsQuery(!!accountDetails)
    const cal = calendars?.find((c) => c.id === accountDetails?.settings.calendar_id)
    return {
        data: cal,
        isLoading: isLoading || isCalendarsLoading,
    }
}
